export const subjectConcerns = [
    {
        value: '0',
        subject: 'Bitte wählen ...',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
        ],
    },
    {
        value: '1',
        subject: 'Bestellung/Lieferung',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich kann nicht bestellen',
            },
            {
                value: '2',
                concern: 'Ich möchte eine Bestellung ändern',
                additionalFields: [
                    {type: 'text', label: 'Auftragsnummer', name: 'orderNumber'},
                ],
            },
            {
                value: '3',
                concern: 'Ich möchte eine Bestellung stornieren',
                additionalFields: [
                    {type: 'text', label: 'Auftragsnummer', name: 'orderNumber'},
                ],
            },
            {
                value: '4',
                concern: 'Ich möchte meine Sendung an eine neue Adresse umleiten',
            },
            {
                value: '5',
                concern: 'Wo bleibt meine Ware?',
            },
            {
                value: '6',
                concern: 'Warum wurde meine Bestellung gesperrt?',
            },
            {
                value: '7',
                concern: 'Ich habe einen falschen Artikel erhalten',
                additionalFields: [
                    {type: 'text', label: 'Rechnungsnummer', name: 'invoiceNumber'},
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                ],
            },
        ],
    },
    {
        value: '2',
        subject: 'Konto/Rechnung',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich habe eine Frage zu meiner Rechnung',
            },
            {
                value: '2',
                concern: 'Ich habe eine Mahnung erhalten',
            },
            {
                value: '3',
                concern: 'Ich möchte eine andere Zahlungsweise nutzen',
            },
            {
                value: '4',
                concern: 'Ich möchte per Rechnung zahlen',
            },
            {
                value: '5',
                concern: 'Ich habe Fragen oder Hinweise zu meiner Zahlung',
            },
            {
                value: '6',
                concern: 'Wie ist mein Kontostand?',
            },
            {
                value: '7',
                concern: 'Ich möchte mein Guthaben zurück',
            },
        ],
    },
    {
        value: '3',
        subject: 'Rücksendung',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich möchte Ware zurückschicken/ eine Ersatzbestellung platizieren',
            },
            {
                value: '2',
                concern: 'Eine Gutschrift fehlt',
            },
        ],
    },
    {
        value: '4',
        subject: 'Persönliche Daten/Benutzerkonto',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich habe meine Kundennummer vergessen',
            },
            {
                value: '2',
                concern: 'Ich habe mein Passwort vergessen',
            },
            {
                value: '3',
                concern: 'Ich möchte mich für „Mein Konto“ anmelden',
            },
            {
                value: '4',
                concern: 'Ich möchte meine persönliche Daten ändern',
            },
            {
                value: '5',
                concern: 'Ich möchte meine Daten löschen',
            },
        ],
    },
    {
        value: '5',
        subject: 'Artikel',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich brauche mehr Artikelinformationen',
            },
            {
                value: '2',
                concern: 'Mein Artikel hat einen Mangel',
                additionalFields: [
                    {type: 'text', label: 'Rechnungsnummer', name: 'invoiceNumber'},
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                ],
            },
            {
                value: '3',
                concern: 'Ein Artikel ist ausverkauft - wann ist er wieder verfügbarEin Artikel ist ausverkauft - wann ist er wieder verfügbar',
            },
            {
                value: '4',
                concern: 'Ich habe eine Frage zum Preis',
            },
            {
                value: '5',
                concern: 'Ich habe eine Frage zur Größe',
            },
            {
                value: '6',
                concern: 'Meldung von potenziellen Verletzungen',
                additionalFields: [
                    {type: 'text', label: 'Artikelnummer', name: 'articleNumber'},
                    {type: 'text', label: 'Größe', name: 'articleSize'},
                ],
            },
        ]
    },
    {
        value: '6',
        subject: 'Gutschein',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich habe eine Frage zu meinem Gutschein',
                additionalFields: [
                    {type: 'text', label: 'Gutschein-Code oder Newsletter-Betreff', name: 'voucherCode'},
                    {type: 'text', label: 'Höhe des Rabatts', name: 'discountAmount'},
                ]
            },
        ]
    },
    {
        value: '7',
        subject: 'Newsletter/Katalog',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich möchte Ihren Newsletter oder Katalog',
            },
            {
                value: '2',
                concern: 'Ich möchte keinen Newsletter oder Katalog mehr',
            },
        ]
    },
    {
        value: '8',
        subject: 'Barrierefreiheit',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Ich habe eine Anmerkung oder eine Frage zur Webseite',
            },
        ],
    },
    {
        value: '9',
        subject: 'Sonstige Fragen',
        concerns: [
            {
                value: '0',
                concern: 'Bitte wählen ...',
            },
            {
                value: '1',
                concern: 'Sonstige Fragen',
            },
            {
                value: '2',
                concern: 'Ich habe eine Frage zur Webseite',
            },
        ]
    },
];
